import React from 'react';
import { Typography, Tooltip, withStyles } from '@material-ui/core';
import { Reorder, CalendarToday } from '@material-ui/icons';
import swal from 'sweetalert2';
import { Base64 } from 'js-base64';
import CycleTitle from '../common/CycleTitle';
import ProcessButtons from '../common/ProcessButtons_v2';
import { updateCycleTitle, initTask, addTaskToCycle, updateTasksOrder, removeTaskFromCycle, updateCycleDueDate, updateTaskDueDate } from '../../firebase/db';
import * as routes from '../../routes/routes';
import { FIREBASE_PROJECT_ID } from '../../firebase-config';
import { areThereDocumentsInCycle, deleteCycle, toggleActiveTaskInCycle } from '../../firebase/db/cycle';

const styles = theme => ({
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 20
  },
  previewOpt: {
    // marginLeft: 20
  },
  removeCycle: {
    float: 'left',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  selectedIcon: {
    fontSize: 25
  },
  icon: {
    fontSize: 25,
    color: 'gray'
  },
  page: {
    margin: '10px 100px 5px 100px'
  }
});

class ProjectCycles extends React.Component {
  state = {
    tasks: {},
    orderBy: 'index'
  };

  onCycleNameChange = (event) => {
    const obj = Object.assign({}, this.state.cycle);
    obj.title = event.target.value;
    this.setState({ cycle: obj });
  };

  onTitleBlur = (title) => {
    const { cycleId } = this.props;
    updateCycleTitle(cycleId, title);
  };


  onPropertyNameBlur = () => {
    // todo povezivanje sa bazom;
  }

  handleAddProperty = (type) => {
    const { cycle: { project }, cycleId, auth: { email } } = this.props;
    initTask(project, cycleId, email)
      .then(taskId => addTaskToCycle(cycleId, taskId, type));
  };

  handlePropertyChange = (propertyName, index, field, value) => {
    this.setState((state) => {
      const property = state.tasks[propertyName];
      property[index][field] = value;
      return { ...state.tasks, property };
    });
  };

  handlePropertyBlur = (propertyName, index, field, value) => {
    // TODO update the task name
  };

  handleDeleteProperty = (propertyName, index) => {
    this.setState((state) => {
      const property = state[propertyName];
      property.splice(index, 1);
      return { ...state, property };
    });
  };

  handleTaskClick = (taskId) => {
    const { history, cycle: { project }, cycleId, projectId, onTaskClick } = this.props;
    // history.push(routes.CYCLE_TASK, { projectId: project, cycleId, taskId });
    onTaskClick(taskId);
  };

  handleTaskReorder = (phase, orderedTasks) => {
    const { cycleId } = this.props;
    updateTasksOrder(cycleId, phase, orderedTasks);
  };

  handleTaskRemove = (phase, taskId, taskName) => {
    const { cycleId } = this.props;
    swal({
      title: `Wollen Sie wirklich den Task ${taskName} wirklich löschen?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#54be89',
      cancelButtonColor: '#ef6920',
      confirmButtonText: 'OK',
      cancelButtonText: 'CANCEL'
    }).then((result) => {
      if (result.value) {
        removeTaskFromCycle(cycleId, phase, taskId)
          .then(() => {
            return swal(
              'Deleted!',
              'success'
            )
          })
          .catch(console.log);
      }
    });
  };

  handleDueDateChange = (phase, value) => {
    const { cycleId } = this.props;
    updateCycleDueDate(cycleId, phase, value)
      .then(console.log)
      .catch(console.log);
  };

  handleTaskDueDateChange = (phase, taskId, dueDate) => {
    const { cycleId } = this.props;
    updateTaskDueDate(cycleId, phase, taskId, dueDate)
      .then(console.log)
      .catch(console.log);
  };

  handleActiveTaskToggle = (taskId, phase, active) => {
    const { cycleId } = this.props;
    toggleActiveTaskInCycle(cycleId, taskId, phase, active);
  };

  handleDeleteCycle = () => {
    const { cycle, auth, cycleId, onCycleDelete } = this.props;

    if (Base64.encode(auth.email) !== cycle.createdBy) {
      swal({
        title: `You can not delete ${cycle.index + 1} because you are not the owner!`,
        type: 'warning',
        confirmButtonColor: '#54be89',
        confirmButtonText: 'OK'
      });
      return;
    }
    swal({
      title: `Wollen Sie wirklich den Cycle ${cycle.index + 1} löschen?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#54be89',
      cancelButtonColor: '#ef6920',
      confirmButtonText: 'OK',
      cancelButtonText: 'CANCEL'
    })
      .then((result) => {
        if (!result.value) {
          return Promise.reject(new Error('Delete of cycle canceled'));
        }
        return areThereDocumentsInCycle(cycleId);
      })
      .then((documentsExists) => {
        if (!documentsExists) {
          return onCycleDelete(cycleId);
        }
        return swal({
          title: `Es gibt Dokumente und erledigte Tasks die mit Cycle verknüpft sind, wollen Sie wirklich den Cycle ${cycle.index + 1} und alle Dokumente löschen?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#54be89',
          cancelButtonColor: '#ef6920',
          confirmButtonText: 'OK',
          cancelButtonText: 'CANCEL'
        })
          .then((result) => {
            if (!result.value) {
              return Promise.reject(new Error('Delete of cycle canceled'));
            }
            return onCycleDelete(cycleId);
          });
      })
      .catch(console.log);
  };

  render() {
    if (!this.props.cycle.tasks) return null;
    const { cycle: { title, dueDates, tasks: { define, build, test, learn } }, projectTitle, index, subTaskAssigned, cycleId, classes } = this.props;
    const { orderBy } = this.state;
    return (
      <div>
        <div className={classes.titleBar}>
          <div className={classes.previewOpt}>
            <Tooltip title="ordnen nach Index">
              <Reorder
                className={
                  (orderBy === 'index')
                    ? classes.selectedIcon
                    : classes.icon}
                onClick={() => this.setState({ orderBy: 'index' })}
              />
            </Tooltip>
            <Tooltip title="ordnen nach Datum">
              <CalendarToday
                className={
                  (orderBy === 'date')
                    ? classes.selectedIcon
                    : classes.icon}
                onClick={() => this.setState({ orderBy: 'date' })}
              />
            </Tooltip>
          </div>
          <CycleTitle
            title={title}
            onTitleChange={this.onCycleNameChange}
            onTitleBlur={this.onTitleBlur}
          />
          <div className={classes.removeCycle} onClick={this.handleDeleteCycle}>
            <Typography color="primary" variant="subheading">Cycle löschen</Typography>
            <img
              src={FIREBASE_PROJECT_ID === 'uxs-autumn' ? require('../../icons/trash-red.svg') : require('../../icons/trash-blue.svg')}
              height="25"
              width="25"
              alt="Delete"
            />
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-around' }}>
            <ProcessButtons
              cycleId={cycleId}
              name="Learn"
              arrayName="learn"
              arrayForMap={learn || {}}
              onAddProperty={this.handleAddProperty}
              onDeleteProperty={this.handleDeleteProperty}
              onPropertyNameChange={this.handlePropertyChange}
              onPropertyNameBlur={this.onPropertyNameBlur}
              onTaskClick={this.handleTaskClick}
              onTaskReorder={this.handleTaskReorder}
              onTaskRemove={(taskId, name) => this.handleTaskRemove('learn', taskId, name)}
              dueDate={(dueDates && dueDates.learn) ? dueDates.learn : ''}
              onDueDateChange={value => this.handleDueDateChange('learn', value)}
              onTaskDueDateChange={this.handleTaskDueDateChange}
              subTaskAssigned={subTaskAssigned}
              orderBy={orderBy}
              onActiveTaskToggle={(taskId, active) => this.handleActiveTaskToggle(taskId, 'learn', active)}
            />
            <ProcessButtons
              cycleId={cycleId}
              name="Define"
              arrayName="define"
              arrayForMap={define || {}}
              onAddProperty={this.handleAddProperty}
              onDeleteProperty={this.handleDeleteProperty}
              onPropertyNameChange={this.handlePropertyChange}
              onPropertyNameBlur={this.onPropertyNameBlur}
              onTaskClick={this.handleTaskClick}
              onTaskReorder={this.handleTaskReorder}
              onTaskRemove={(taskId, name) => this.handleTaskRemove('define', taskId, name)}
              dueDate={(dueDates && dueDates.define) ? dueDates.define : ''}
              onDueDateChange={value => this.handleDueDateChange('define', value)}
              onTaskDueDateChange={this.handleTaskDueDateChange}
              subTaskAssigned={subTaskAssigned}
              orderBy={orderBy}
              onActiveTaskToggle={(taskId, active) => this.handleActiveTaskToggle(taskId, 'define', active)}
            />
            <ProcessButtons
              cycleId={cycleId}
              name="Build"
              arrayName="build"
              arrayForMap={build || {}}
              onAddProperty={this.handleAddProperty}
              onDeleteProperty={this.handleDeleteProperty}
              onPropertyNameChange={this.handlePropertyChange}
              onPropertyNameBlur={this.onPropertyNameBlur}
              onTaskClick={this.handleTaskClick}
              onTaskReorder={this.handleTaskReorder}
              onTaskRemove={(taskId, name) => this.handleTaskRemove('build', taskId, name)}
              dueDate={(dueDates && dueDates.build) ? dueDates.build : ''}
              onDueDateChange={value => this.handleDueDateChange('build', value)}
              onTaskDueDateChange={this.handleTaskDueDateChange}
              subTaskAssigned={subTaskAssigned}
              orderBy={orderBy}
              onActiveTaskToggle={(taskId, active) => this.handleActiveTaskToggle(taskId, 'build', active)}
            />
            <ProcessButtons
              cycleId={cycleId}
              name="Test"
              arrayName="test"
              arrayForMap={test || {}}
              onAddProperty={this.handleAddProperty}
              onDeleteProperty={this.handleDeleteProperty}
              onPropertyNameChange={this.handlePropertyChange}
              onPropertyNameBlur={this.onPropertyNameBlur}
              onTaskClick={this.handleTaskClick}
              onTaskReorder={this.handleTaskReorder}
              onTaskRemove={(taskId, name) => this.handleTaskRemove('test', taskId, name)}
              dueDate={(dueDates && dueDates.test) ? dueDates.test : ''}
              onDueDateChange={value => this.handleDueDateChange('test', value)}
              onTaskDueDateChange={this.handleTaskDueDateChange}
              subTaskAssigned={subTaskAssigned}
              orderBy={orderBy}
              onActiveTaskToggle={(taskId, active) => this.handleActiveTaskToggle(taskId, 'test', active)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ProjectCycles);



// WEBPACK FOOTER //
// ./src/components/Cycles/ProjectCycles.js